import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { FormDialogTemplate } from "../../../../shared/form-dialog/form-dialog.template";

@Injectable()
export class UploadService {
    showApplyReport: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    showProgramSelect: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    showInvalidColumns: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
    partInvalid: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
    throughputInvalid: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
    currentData: any;
    constructor() {

    }

    setPartInvalidGrid(data: any) {
        this.partInvalid.next(data);
    }

    setThroughputInvalidGrid(data: any) {
        this.throughputInvalid.next(data);
    }

    getPartInvalidGrid() {
        return this.partInvalid.value;
    }

    getThroughputInvalidGrid() {
        return this.throughputInvalid.value;
    }

    getThroughputData() {

        return this.currentData;
    }
}
